import { rejectAll } from '../../GoalResolvers';
import { State } from '../../State';
import { destroy } from './destroy';
import { disable } from './disable';
import { downgrade } from './downgrade';
import { logOut } from './logOut';
import { rebuild } from './rebuild';
import { restart } from './restart';
import { start } from './start';
import { stop } from './stop';

// Regardless of how it got there, certain states will make life cycle changes, such as:
// * Preparing a new task.
// * Dowgrading
// * Disabling

export function reduceLifeCycle(state: State): State {
  // Do not make any life cycle changes if there's already a task running;
  // it must run to completion before proceeding.
  if (state.currentTask) return state;

  if (!state.featureFlags.syncEnhancements && !state.legacy) {
    return downgrade(state);
  }

  if (state.featureFlags.syncEnhancements && state.legacy) {
    // TODO: This is a temp update for main branch v1 replication as we should never be turning
    // on the syncEnhancements flag for legacy replication. We should remove this once we have v2 replication in main.
    // Making a note so it is not missed during merge replication-v2 to main.
    return state;
  }

  if (state.legacy) return state;

  let goalResolvers = state.goalResolvers;

  if (goalResolvers.LogOut.length) {
    return logOut(state);
  }

  if (goalResolvers.Disable.length) {
    return disable(state);
  }

  if (goalResolvers.Rebuild.length) {
    return rebuild(state);
  }

  if (goalResolvers.Destroy.length) {
    return destroy(state);
  }

  if (state.disabled) {
    goalResolvers = rejectAll(goalResolvers, 'Disabled');
    return {
      ...state,
      goalResolvers,
    };
  }

  if (goalResolvers.Restart.length) {
    return restart(state);
  }

  if (goalResolvers.Stop.length) {
    return stop(state);
  }

  return start(state);
}
